<div class="tr-modal-wrapper">
    <div class="modal fade show d-block tr-modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body text-center">
                    <p class="text-details mb-4">{{ infoText }}</p>
                    <button type="button" class="btn tr-btn-primary" (click)="onCloseClick()">{{ 'marketplace.close' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="backdrop"></div>
</div>
  